import React, { useRef, useLayoutEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "./Quate.module.css";
import quate from  '../images/הבית של רתם ואורטל בבאר גנים 2.JPG';

// Register Plugin
gsap.registerPlugin(ScrollTrigger);

const ShirliQuate = () => {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  const sentence =
    "עיצוב טוב הוא לא רק יפה – הוא פונקציונלי, חכם ומותאם בדיוק לצרכים שלכם";
  const words = sentence.split(" ");

  // הסרנו את ה-useEffect של Lenis מכאן.
  // GSAP ScrollTrigger עובד מצוין עם גלילה טבעית של הדפדפן.

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const fills = textRef.current.querySelectorAll(`.${styles.wordFill}`);

      // מצב התחלתי
      gsap.set(fills, { opacity: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top top", // כשהחלק העליון של הקונטיינר מגיע לחלק העליון של המסך
          end: "+=150%", // קיצרתי מעט את האורך כדי למנוע "זמן מת" מיותר, ניתן לשנות חזרה ל-180%
          scrub: 1, // זה מה שנותן את האפקט החלק לאנימציה עצמה!
          pin: true, // נועל את המסך
          // מונע בעיות חישוב אם הגלילה מהירה מדי בטלפונים
          fastScrollEnd: true, 
        }
      });

      fills.forEach((word) => {
        tl.to(
          word,
          {
            opacity: 1,
            duration: 0.4,
            ease: "none" // עדיף none בתוך scrub ליניארי
          },
          "+=0.1" // רווח קטן בין מילים
        );
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={containerRef} className={styles.section}>
      <img className={styles.bg} src={quate} alt="" />
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h2 ref={textRef} className={styles.text}>
          {words.map((word, i) => (
            <span key={i} className={styles.word}>
              <span className={styles.wordBase}>{word}</span>
              <span className={styles.wordFill}>{word}</span>
            </span>
          ))}
        </h2>
      </div>
    </section>
  );
};

export default ShirliQuate;